"use client";

import React from "react";
import { FileText } from "lucide-react";
import { ReusableTemplateSelector } from "@/components/shared/ReusableTemplateSelector";
import { TaskTemplate } from "@/lib/types/task-templates";
import { TemplateSelectorProps, BaseTemplate } from "@/components/shared/UniversalEntityPage/types";

export const TaskTemplateSelector: React.FC<TemplateSelectorProps<TaskTemplate>> = ({
  onTemplateSelect,
  selectedTemplate,
  className = "",
}) => {
  // TaskTemplate already extends BaseTemplate, so we can use ReusableTemplateSelector directly
  // Convert callback to accept BaseTemplate (TaskTemplate extends BaseTemplate)
  const handleTemplateSelect = (template: BaseTemplate | null) => {
    // Cast is safe because ReusableTemplateSelector with templateType="task" returns TaskTemplate
    onTemplateSelect(template as TaskTemplate | null);
  };

  return (
    <ReusableTemplateSelector
      templateType="task"
      selectedTemplate={selectedTemplate} // Direct pass - TaskTemplate extends BaseTemplate
      onTemplateSelect={handleTemplateSelect}
      placeholder="Select a task template or start from scratch..."
      searchPlaceholder="Search task templates..."
      className={className}
      icon={<FileText className="h-4 w-4 text-gray-500" />}
      label="Task Template"
    />
  );
};

export default TaskTemplateSelector;
